import React, { useEffect, useState } from 'react';
import { useJobFormContext } from '../JobFormContext';
import { useKidPetContext } from '../contexts/KidPetContext';
import FormField from './FormField';
import KidCard from '../../../reusableComponents/kidCard';
import Inline from '../../../reusableComponents/inline';
import Input from '../../../reusableComponents/input';
import { AddCircle, HighlightOff } from '@material-ui/icons';
import { Typography, Grid } from '@material-ui/core';
import { Colors } from 'library';
import moment from 'moment';
import { UnpostedKid } from 'models/UnpostedKid';
import { JobTypeIds } from 'models/JobType';

export default function AddKids() {
    const [kidsIndex, setKidsIndex] = useState(0);
    const { form } = useJobFormContext();
    const { unpostedKids, setUnpostedKids } = useKidPetContext();
    const [isPetcare, setIsPetcare] = useState(false);

    useEffect(() => {
        const petcareUpdate = form.fieldStates.jobTypeId.value === JobTypeIds.PetCare;
        setIsPetcare(petcareUpdate);
        unpostedKids.forEach((kid) => {
            kid.type = petcareUpdate ? 'PET' : 'CHILD';
        });
    }, [form.fieldStates.jobTypeId]);

    const validate = (kids: UnpostedKid[]) => {
        let valid = true;
        for (let i = 0; i < kids.length; i++) {
            if (!kids[i].isName || (!kids[i].isBirthday && !isPetcare)) {
                valid = false;
            }
            if (!kids[i].type) {
                kids[i].type = isPetcare ? 'PET' : 'CHILD';
            }
        }
        form.fieldStates.kids.setValid(valid);
    };

    const validateBirthday = (birthday: string) => {
        var now = moment(new Date()).format('YYYY');
        var parsedBirthday = birthday.split('-');
        if (
            parsedBirthday[0].length === 0 ||
            1920 > parseInt(parsedBirthday[0]) ||
            parseInt(parsedBirthday[0]) > parseInt(now)
        ) {
            return false;
        } else {
            return true;
        }
    };

    const onChangeTextKid = (id: number, type: string, value: string) => {
        let kids_copy = [...unpostedKids];
        for (let i = 0; i < unpostedKids.length; i++) {
            if (unpostedKids[i].id === id) {
                let kid = { ...kids_copy[i] };
                if (type === 'name') {
                    kid.name = value;
                    kid.isName = value.length > 0;
                } else if (type === 'birthday') {
                    kid.birthday = value;
                    kid.isBirthday = validateBirthday(value);
                } else if (type === 'comments') {
                    kid.comments = value;
                }
                kids_copy[i] = kid;
            }
        }
        setUnpostedKids(kids_copy);
        validate(kids_copy);
    };

    const addKid = () => {
        const addedKid = {
            id: kidsIndex + 1,
            name: '',
            birthday: '',
            comments: '',
            type: isPetcare ? 'PET' : 'CHILD',
            isName: false,
            isBirthday: false,
            isType: true,
        };

        setKidsIndex(kidsIndex + 1);
        setUnpostedKids([...unpostedKids, addedKid]);
        validate([...unpostedKids, addedKid]);
    };

    const removeKid = (id: number) => {
        const newArray = unpostedKids.filter((ele) => ele.id != id);
        setUnpostedKids(newArray);

        validate(newArray);
    };

    return (
        <Grid>
            {unpostedKids.map((kid, i) => (
                <Inline spacing={2} key={kid.id} margin={false}>
                    <Grid xs={11}>
                        <KidCard>
                            <Grid item sm={4} xs={12}>
                                <FormField title="Name*">
                                    <Input
                                        required
                                        error={!kid.isName}
                                        fullWidth
                                        id={`add-kid-name-input-${i}`}
                                        title="Name"
                                        value={kid.name}
                                        onChange={(e) => onChangeTextKid(kid.id, 'name', e.target.value)}
                                    />
                                </FormField>
                            </Grid>
                            {!isPetcare && (
                                <Grid item sm={4} xs={12}>
                                    <FormField title={'Birthday*'}>
                                        <Input
                                            required={!isPetcare}
                                            error={!kid.isBirthday}
                                            id={`add-kid-birthday-input-${i}`}
                                            InputLabelProps={{ shrink: true }}
                                            type="month"
                                            fullWidth
                                            value={kid.birthday}
                                            style={{ width: '100%' }}
                                            onChange={(e) => onChangeTextKid(kid.id, 'birthday', e.target.value)}
                                        />
                                    </FormField>
                                </Grid>
                            )}
                            <Grid item sm={11} xs={12}>
                                <FormField title="Additional Comments">
                                    <Input
                                        fullWidth
                                        id={`add-kid-comment-input-${i}`}
                                        helperText="(Allergies, special needs, etc.)"
                                        value={kid.comments}
                                        onChange={(e) => onChangeTextKid(kid.id, 'comments', e.target.value)}
                                    />
                                </FormField>
                            </Grid>
                        </KidCard>
                    </Grid>
                    {kid.id !== 0 ? (
                        <Grid container xs={1}>
                            <HighlightOff
                                style={{
                                    position: 'relative',
                                    top: '25%',
                                    color: Colors.darkNavy,
                                }}
                                onClick={() => removeKid(kid.id)}
                            />
                        </Grid>
                    ) : null}
                </Inline>
            ))}
            <Grid container item direction="row" alignItems="center" spacing={3}>
                <Grid item>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                        Add another {isPetcare ? 'pet' : 'child'}
                    </Typography>
                </Grid>
                <Grid item xs={1}>
                    <AddCircle
                        style={{ position: 'relative', color: Colors.darkNavy }}
                        onClick={() => addKid()}
                        id="add-kid-add-circle"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
